const PipelineStatusType = Object.freeze({
  IDLE: "IDLE",
  STARTED: "STARTED",
  COLLECTING: "COLLECTING",
  IN_PROGRESS: "IN_PROGRESS",
  ERROR: "ERROR",
  CANCELLED: "CANCELLED",
});

export default PipelineStatusType;

export const getExecutionStatusDescription = (status) => {
  switch (status) {
    case PipelineStatusType.IDLE:
      return "Não executada";
    case PipelineStatusType.STARTED:
      return "Iniciada";
    case PipelineStatusType.IN_PROGRESS:
      return "Em progresso";
    case PipelineStatusType.COLLECTING:
      return "Coletando eventos";
    case PipelineStatusType.ERROR:
      return "Erro";
    case PipelineStatusType.CANCELLED:
      return "Cancelada";
    default:
      return "N/A";
  }
};
